import { render, staticRenderFns } from "./inspectionContents.vue?vue&type=template&id=da8166d2&scoped=true&"
import script from "./inspectionContents.vue?vue&type=script&lang=ts&"
export * from "./inspectionContents.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionContents.vue?vue&type=style&index=0&id=da8166d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8166d2",
  null
  
)

export default component.exports